import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import PricingPage from "./components/PricingPage";
import ContactPage from "./components/ContactPage";
import SuccessPage from "./components/SuccessPage";
import PDFThankYouPage from "./components/PDFThankYouPage";
import CookieConsent from "./components/CookieConsent";
import BackToTop from "./components/BackToTop";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/pdf-thank-you/:token" element={<PDFThankYouPage />} />
        </Routes>
        <CookieConsent />
        <BackToTop />
      </BrowserRouter>
    </div>
  );
}

export default App;